module.exports = __webpack_public_path__ + "img/hellyerp.fd9791ff.jpg";